import React, { Component, useState, useEffect, useCallback, useMemo } from 'react';
import ReactDOM from "react-dom";
import { useForm } from "react-hook-form";
import Header from "../Landingpagecomponents/Header/header";
import { Grid, Typography, Paper } from "@material-ui/core";
import { makeStyles, withStyles, styled } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';
import Button from "@material-ui/core/Button";
import Slide from "react-reveal/Slide";
import logo5 from "../Landingpagecomponents/images/logo5.png";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import YesNoQuestion from "./questiontypes/yesNoQuestion";
import PictureChoice from "./questiontypes/pictureChoice";
import MultipleChoice from "./questiontypes/multipleChoice";
import ComputerVisionTest from "./questiontypes/cvtest/ComputerVisionTest";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import ListSubheader from '@material-ui/core/ListSubheader';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import EditIcon from '@material-ui/icons/Edit';
import { useMediaQuery } from '@material-ui/core';
//import tileData from './tileData';

// TypingText component for animated word-by-word display
function TypingText({ text, speed = 50 }) {
    const [displayed, setDisplayed] = useState('');
    useEffect(() => {
        // Guard against undefined or null text
        if (!text) {
            setDisplayed('');
            return;
        }
        const words = text.split(' ');
        let i = 0;
        setDisplayed('');
        const interval = setInterval(() => {
            if (i < words.length) {
                setDisplayed(prev => prev + (i === 0 ? '' : ' ') + words[i]);
                i++;
            } else {
                clearInterval(interval);
            }
        }, speed);
        return () => clearInterval(interval);
    }, [text, speed]);
    return <span>{displayed}</span>;
}

const useStyles = makeStyles((theme) => ({
    //Styling for multipleChoice
    multipleChoice: {
        root: {
            '& > *': {
                margin: theme.spacing(0.5),

            },
        },
        button: {
            maxWidth: "300px",
            maxHeight: "40px",
            display: 'flex',
            justifyContent: "center",
            alignItems: "center",
            color: "#002D55",
            borderColor: "#002D55",
            border: "0px solid",
            "&:hover": {
                backgroundColor: "#002d55",
                color: "#FFFFFF",
                borderColor: "#0062cc",
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
                backgroundColor: "#0062cc",
                borderColor: "#005cbf"
            },
            "&:focus": {
                boxShadow: "0 0 0 0.2rem rgba(0, 45, 85, 0.8)"
            }
        }
    },

    dropdown: {
        root: {
            '& > *': {
                margin: theme.spacing(0.5),

            },
        },
        button: {
            display: 'block',
            marginTop: theme.spacing(2),
        },
    },
    //Styling for pictureChoice
    pictureChoice: {
        root: {
            maxWidth: 345,
            margin: 10,
        },
        cardRoot: {
            maxWidth: 345,
            margin: 10,
            color: "#002D55",
            borderColor: "#002D55",
            border: "1px solid",
            "&:hover": {
                backgroundColor: "#002d55",
                color: "#FFFFFF",
                borderColor: "#0062cc",
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
                backgroundColor: "#0062cc",
                borderColor: "#005cbf"
            },
            "&:focus": {
                boxShadow: "0 0 0 0.2rem rgba(0, 45, 85, 0.8)"
            },

        },
        tileMedia: {
            height: 140,

        },
        tileCardGrid: {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8),
        },
        tileRoot: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            overflow: 'hidden',
            backgroundColor: theme.palette.background.paper,
          },
          GridList: {
            width: "100%",
            height: "100%",
          },
          icon: {
            color: 'rgba(255, 255, 255, 0.54)',
          },
    },
    orangeFocused: {
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#fb741a',
        },
        // when label is shrunk (focused) make it dark blue
        '& .MuiInputLabel-outlined.Mui-focused': {
            color: '#002D55',
        },
    },
    button2: {
        color: "#FFFFFF",
        backgroundColor: "#002D55",
        minWidth: 200,
        borderRadius: 18,
        border: 'none',
        boxShadow: 'none',
        marginRight: 8,
        '&:hover': {
          backgroundColor: "#FF7F27",
        }
      },
    confirmButton: {
        minWidth: 200,
        borderRadius: 18,
        fontSize: "clamp(13px, 0.9vw, 16px)",
        fontWeight: 600,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        transition: 'background-color 150ms ease',
        // hover to dark blue when interactive
        '&:hover': {
            backgroundColor: '#fb741a',
            color: '#FFF',
        },
    },
    confirmPending: {
        backgroundColor: '#002D55',
        minWidth: 200,
        color: '#FFF',
        borderRadius: 18,
        '&:hover': {
            backgroundColor: '#fb741a',
        },
    },

}));


function MultipleChoiceComp({ data, selectedChoiceCallback, styleComp, disabled }) {
    const [selectedId, setSelectedId] = useState(null);
    const textWidth = 800;
    

    // Reset selectedId when question changes
    useEffect(() => {
        setSelectedId(null);
    }, [data && data.id]);

    const handleSelect = (answerId) => {
        if (disabled) return;
        setSelectedId(answerId);
        selectedChoiceCallback(answerId);
    };
    // Detect smartphone screen
    const isMobile = useMediaQuery('(max-width:600px)');

    
    // If more than 7 answers, use scroll
    const useScroll = data.answers.length > 6;

    // Layout: title at top, picture left, answer options right
    if (data.pictureUrl) {
        // Card height (estimate): 56px + 6px margin top + 6px margin bottom = 68px per card
        const cardHeight = 56 + 6 + 6; // 68px
        const numCards = Math.min(data.answers.length, 6);
        const maxImgHeight = cardHeight * numCards;
        // Responsive layout: stack vertically on small screens
        return (
            <Grid container direction="column" className={styleComp.root} style={{ margin: 0, marginTop: -5, padding: 20 }}>
                <Typography
                    variant="h5"
                    className={data.questionClassName || ""}
                    style={{ color: "#002D55", maxWidth: textWidth, whiteSpace: 'break-spaces', marginBottom: 20 }}
                >
                    <TypingText text={data.title} speed={0} />
                </Typography>
                <Grid container direction={isMobile ? "column" : "row"} alignItems="flex-start" justifyContent="flex-start" style={{ width: "100%" }}>
                    <Grid item xs={12} md={6} style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', padding: 0 }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                minWidth: isMobile ? '300px' : '32  0px',
                                minHeight: isMobile ? '180px' : '180px',
                                
                                overflow: 'hidden',
                                background: 'transparent',
                                borderRadius: 16
                            }}>
                                <img
                                    src={data.pictureUrl}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        maxHeight: "50vh",
                                        objectFit: 'contain',
                                        borderRadius: 16
                                    }}
                                    alt="question"
                                />
                            </div>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingLeft: isMobile ? 0 : 20, justifyContent: 'flex-start' }}>
                        <div
                            style={{
                                maxHeight: useScroll ? 550 : "unset",
                                overflowY: useScroll ? "auto" : "unset",
                                    width: "100%",
                                    maxWidth: 800,
                                paddingTop: 8,
                            }}
                        >
                            {data.answers.map((item) => (
                                <Grid style={{ alignItems: "center" }} container="row" key={item.answerId}>
                                    <Card
                                        className="assessment-card-responsive"
                                        style={{
                                            marginTop: 2,
                                            marginBottom: 2,
                                            width: isMobile ? "100%" : "80%",
                                            backgroundColor: disabled ? '#f1f5f9' : (selectedId === item.answerId ? "#FF7F27" : "#fff"),
                                            color: disabled ? '#94a3b8' : (selectedId === item.answerId ? "#fff" : "#002D55"),
                                            border: disabled ? '1px solid #e2e8f0' : (selectedId === item.answerId ? "1px solid #FF7F27" : "1px solid rgba(0,45,85,0.28)"),
                                            borderRadius: 999,
                                            boxShadow: selectedId === item.answerId ? '0 4px 14px rgba(255,127,39,0.20)' : 'none',
                                            transition: "background 0.3s, color 0.3s, border 0.3s, box-shadow 0.3s, opacity 0.3s",
                                            boxSizing: 'border-box',
                                            opacity: disabled ? 0.6 : 1,
                                            pointerEvents: disabled ? 'none' : 'auto',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <CardActionArea onClick={() => handleSelect(item.answerId)} disabled={disabled}>
                                                <Typography
                                                
                                                    variant="h7"
                                                    style={{
                                                        color: disabled ? '#94a3b8' : (selectedId === item.answerId ? "#fff" : "#002D55"),
                                                        marginTop: 0,
                                                        marginBottom: 0,
                                                        textAlign: "left",
                                                        fontSize: isMobile ? undefined : 16,
                                                        padding: '10px 16px',
                                                        fontWeight: 600,
                                                    }}
                                                    component="p"
                                                >
                                                    {item.answerText}
                                                </Typography>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))}
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        );
    } else {
        // No picture, default layout
        return (
            <Grid container direction="column" className={styleComp.root} style={{ padding: 10 }}>
                <Typography
                    variant="h5"
                    className={data.questionClassName || ""}
                    style={{ color: "#002D55", maxWidth: textWidth, whiteSpace: 'break-spaces', marginRight: 20, marginBottom: 10 }}
                >
                    <TypingText text={data.title} speed={0} />
                </Typography>
                <div
                    style={{
                        maxHeight: useScroll ? 500 : "unset",
                        overflowY: useScroll ? "auto" : "unset",
                        maxWidth: textWidth,
                        width: "auto",
                        paddingTop: 0,
                    }}
                >
                    {data.answers.map((item) => (
                        <Grid style={{ alignItems: "center" }} container="row" key={item.answerId}>
                            <Card
                                className="assessment-card-responsive"
                                style={{
                                    marginTop: 2,
                                    marginBottom: 2,
                                    width: isMobile ? "100%" : "80%",
                                    backgroundColor: disabled ? '#f1f5f9' : (selectedId === item.answerId ? "#FF7F27" : "#fff"),
                                    color: disabled ? '#94a3b8' : (selectedId === item.answerId ? "#fff" : "#002D55"),
                                    border: disabled ? '1px solid #e2e8f0' : (selectedId === item.answerId ? "1px solid #FF7F27" : "1px solid rgba(0,45,85,0.28)"),
                                    borderRadius: 999,
                                    boxShadow: selectedId === item.answerId ? '0 4px 14px rgba(255,127,39,0.20)' : 'none',
                                    transition: "background 0.3s, color 0.3s, border 0.3s, box-shadow 0.3s, opacity 0.3s",
                                    boxSizing: 'border-box',
                                    opacity: disabled ? 0.6 : 1,
                                    pointerEvents: disabled ? 'none' : 'auto',
                                    overflow: 'hidden',
                                }}
                            >
                                <CardActionArea onClick={() => handleSelect(item.answerId)} disabled={disabled}>
                                        <Typography
                                         
                                            variant="h7"
                                            style={{
                                                color: disabled ? '#94a3b8' : (selectedId === item.answerId ? "#fff" : "#002D55"),
                                                marginTop: 0,
                                                marginBottom: 0,
                                                textAlign: "left",
                                                fontSize: isMobile ? undefined : 16,
                                                padding: '10px 16px',
                                                fontWeight: 600,
                                            }}
                                            component="p"
                                        >
                                            {item.answerText}
                                        </Typography>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </div>
            </Grid>
        );
    }
}

/**
 * AngleGauge — SVG half-circle gauge with dual live readouts.
 *
 * Always shows two values:
 *   • Current (live, smooth) — thin dashed needle + numeric readout
 *   • Max (best achieved)   — bold solid needle + large numeric readout
 */
function AngleGauge({ currentAngle, bestAngle, maxAngle, answerMapping, normalRange, centeredZero = false }) {
    const W = 280, H = 190;
    const cx = W / 2, cy = H - 30;
    const R = 110;
    const rInner = 85;
    const strokeW = R - rInner;

    const zoneColors = (idx, total) => {
        if (total <= 1) return '#4caf50';
        if (total === 2) return idx === 0 ? '#f44336' : '#4caf50';
        if (idx === 0) return '#f44336';
        if (idx === total - 1) return '#4caf50';
        const t = idx / (total - 1);
        return t < 0.5 ? '#ff9800' : '#8bc34a';
    };

    const valueToRad = (v) => {
        if (centeredZero) {
            const clamped = Math.max(-maxAngle, Math.min(maxAngle, v));
            return Math.PI * (1 - (clamped + maxAngle) / (2 * maxAngle));
        }
        const clamped = Math.min(Math.max(v, 0), maxAngle);
        return Math.PI * (1 - clamped / maxAngle);
    };

    const arcPath = (startVal, endVal, r) => {
        const s = valueToRad(startVal);
        const e = valueToRad(endVal);
        const x1 = cx + r * Math.cos(s), y1 = cy - r * Math.sin(s);
        const x2 = cx + r * Math.cos(e), y2 = cy - r * Math.sin(e);
        const largeArc = Math.abs(s - e) > Math.PI ? 1 : 0;
        return `M ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2}`;
    };

    const needleEnd = (v, len) => {
        const rad = valueToRad(v);
        return { x: cx + len * Math.cos(rad), y: cy - len * Math.sin(rad) };
    };

    const midR = (R + rInner) / 2;
    const best = Math.round(bestAngle || 0);
    const current = Math.round(currentAngle || 0);

    const bestTip = needleEnd(best, R + 4);
    const bestDot = needleEnd(best, midR);
    const currentTip = needleEnd(current, midR);

    return (
        <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} style={{ display: 'block', margin: '0 auto' }}>
            {/* Background arc */}
            <path d={arcPath(0, maxAngle, midR)} fill="none" stroke="#e0e0e0" strokeWidth={strokeW} strokeLinecap="butt" />

            {/* Zone segments */}
            {answerMapping && answerMapping.map((zone, i) => {
                const segStart = Math.max(zone.min_angle, 0);
                const segEnd = Math.min(zone.max_angle, maxAngle);
                if (segEnd <= segStart) return null;
                if (centeredZero) {
                    return (
                        <React.Fragment key={zone.answer_id}>
                            <path
                                d={arcPath(-segEnd, -segStart, midR)}
                                fill="none"
                                stroke={zoneColors(i, answerMapping.length)}
                                strokeWidth={strokeW}
                                strokeLinecap="butt"
                                opacity={0.7}
                            />
                            <path
                                d={arcPath(segStart, segEnd, midR)}
                                fill="none"
                                stroke={zoneColors(i, answerMapping.length)}
                                strokeWidth={strokeW}
                                strokeLinecap="butt"
                                opacity={0.7}
                            />
                        </React.Fragment>
                    );
                }
                return (
                    <path
                        key={zone.answer_id}
                        d={arcPath(segStart, segEnd, midR)}
                        fill="none"
                        stroke={zoneColors(i, answerMapping.length)}
                        strokeWidth={strokeW}
                        strokeLinecap="butt"
                        opacity={0.7}
                    />
                );
            })}

            {/* Normal range indicator */}
            {normalRange && !centeredZero && (
                <path
                    d={arcPath(normalRange.min_normal, Math.min(normalRange.max_normal, maxAngle), R + 6)}
                    fill="none"
                    stroke="#4caf50"
                    strokeWidth={3}
                    strokeLinecap="round"
                    opacity={0.5}
                />
            )}

            {/* Current angle needle — thin dashed, always visible */}
            <line
                x1={cx} y1={cy}
                x2={currentTip.x} y2={currentTip.y}
                stroke="#5c8ab5"
                strokeWidth={2}
                strokeLinecap="round"
                strokeDasharray="5 3"
            />
            <circle cx={currentTip.x} cy={currentTip.y} r={3} fill="#5c8ab5" />

            {/* Max angle needle — bold solid */}
            <line
                x1={cx} y1={cy}
                x2={bestTip.x} y2={bestTip.y}
                stroke="#002D55"
                strokeWidth={3}
                strokeLinecap="round"
            />
            <circle cx={bestDot.x} cy={bestDot.y} r={5} fill="#002D55" />

            {/* Center pivot */}
            <circle cx={cx} cy={cy} r={4} fill="#002D55" />

            {/* Scale labels */}
            {centeredZero ? (
                <>
                    <text x={cx - R - 8} y={cy + 4} textAnchor="end" fontSize="11" fill="#888">90°</text>
                    <text x={cx} y={cy - R - 8} textAnchor="middle" fontSize="11" fill="#888">Center 0°</text>
                    <text x={cx + R + 8} y={cy + 4} textAnchor="start" fontSize="11" fill="#888">90°</text>
                </>
            ) : (
                <>
                    <text x={cx - R - 8} y={cy + 4} textAnchor="end" fontSize="11" fill="#888">0°</text>
                    <text x={cx + R + 8} y={cy + 4} textAnchor="start" fontSize="11" fill="#888">{maxAngle}°</text>
                </>
            )}

            {/* Max value — large, center */}
            <text x={cx} y={cy - 36} textAnchor="middle" fontSize="28" fontWeight="700" fill="#002D55">
                {best}°
            </text>
            <text x={cx} y={cy - 18} textAnchor="middle" fontSize="11" fontWeight="600" fill="#002D55">
                Current
            </text>

           
        </svg>
    );
}

/**
 * HybridCvMultipleChoice — multipleChoice with optional camera test.
 *
 * Two modes controlled by data.cvAnswerMappingMode:
 *
 * "cv_measure" (movement tests / ROM):
 *   CV provides the precise measurement. On success it shows a half-circle gauge
 *   with the measured angle, lets patient retry for a better measurement, and
 *   requires explicit acceptance. Saves a ComputerVisionTestResult with precise value.
 *   Answer cards are shown as a de-emphasised fallback if the patient skips the camera.
 *
 * "cv_guided" (clinical tests):
 *   CV guides & validates the patient's movement (correct form, compensations).
 *   Once the test is validated the answer cards appear and the patient picks their
 *   subjective response. If the patient skips the camera, cards show immediately.
 */
function HybridCvMultipleChoice({ data, selectedChoiceCallback, styleComp }) {
    const classes = useStyles();
    const [cvMode, setCvMode] = useState('question'); // question | offer | active | validated
    const [cvResult, setCvResult] = useState(null);
    const [cvResultId, setCvResultId] = useState(null);
    const [manualSubmitSignal, setManualSubmitSignal] = useState(0);
    const [isMeasuringStarted, setIsMeasuringStarted] = useState(false);
    const [cvRuntimeStatus, setCvRuntimeStatus] = useState('loading');
    const [autoStartMeasurePending, setAutoStartMeasurePending] = useState(false);

    // Live angle tracking for real-time gauge (cv_measure)
    const [liveMaxAngle, setLiveMaxAngle] = useState(0);
    const [liveCurrentAngle, setLiveCurrentAngle] = useState(0);
    const smoothedAngleRef = React.useRef(0);
    const rawAngleWindowRef = React.useRef([]);
    const gaugeReadyRef = React.useRef(false);

    // Multi-attempt tracking for cv_measure
    const [bestResult, setBestResult] = useState(null);
    const [bestAutoAnswerId, setBestAutoAnswerId] = useState(null);
    const [latestAngle, setLatestAngle] = useState(null);
    const [attemptCount, setAttemptCount] = useState(0);

    const mappingMode = data.cvAnswerMappingMode || 'cv_guided';
    const isMeasure = mappingMode === 'cv_measure';
    const isPoseCheck = mappingMode === 'cv_pose_check';
    const identifier = data.identifier || '';
    const isNeckRotation = (data.cvTestConfig?.testDefinitionName === 'neck_rotation')
        || (data.cvTestConfig?.test_definition_name === 'neck_rotation')
        || /neckrotation/i.test(identifier);
    const centeredRotationGauge = isMeasure && isNeckRotation;
    const isDualLeftQuestion = isMeasure && /neckRotationRangeOfMovementLeft$/i.test(identifier);
    const isDualRightQuestion = /neckRotationRangeOfMovementRight$/i.test(identifier);
    const rightIdentifier = isDualLeftQuestion ? identifier.replace(/Left$/i, 'Right') : null;
    // Sagittal single tests — only capture the relevant direction to avoid contamination
    const isNeckFlexionSolo = isMeasure && /neckFlexionRangeOfMovement(?:Left|Right)?$/i.test(identifier);
    const isNeckExtensionSolo = isMeasure && /neckExtentionRangeOfMovement(?:Left|Right)?$/i.test(identifier);
    const isFreeMeasureFlow = isDualLeftQuestion || isNeckFlexionSolo || isNeckExtensionSolo;

    const [liveTorsoInclination, setLiveTorsoInclination] = useState(null);
    const [dualLeftMaxAngle, setDualLeftMaxAngle] = useState(null);
    const [dualRightMaxAngle, setDualRightMaxAngle] = useState(null);
    const autoFilledRef = React.useRef(false);
    const dualLeftMaxAngleRef = React.useRef(null);
    const dualRightMaxAngleRef = React.useRef(null);
    // Calibration refs for sagittal tests: collect neutral angle during warmup,
    // subtract baseline so that ROM is measured relative to the patient's neutral.
    const calibrationSamplesRef = React.useRef([]);
    const calibrationBaselineRef = React.useRef(null);
    const torsoCalibrationSamplesRef = React.useRef([]);
    const torsoCalibrationBaselineRef = React.useRef(null);
    const headCalibrationSamplesRef = React.useRef([]);
    const headCalibrationBaselineRef = React.useRef(null);
    const sagittalWarmupCandidatesRef = React.useRef([]);
    const rotationWarmupCandidatesRef = React.useRef([]);
    const rotationNeutralSamplesRef = React.useRef([]);
    const rotationAllSamplesRef = React.useRef([]);
    const warmupStartMsRef = React.useRef(null);
    const lastDirectionalAngleRef = React.useRef(null);
    // Pose-check state (cv_pose_check mode — e.g. Bakody, Vasalva)
    const [poseCorrect, setPoseCorrect] = useState(false);
    const poseCorrectSinceRef = React.useRef(null);
    // Hold duration: read from backend movementPhases or fall back per-test default
    const POSE_HOLD_MS = (() => {
        const phases = data.cvTestConfig?.movementPhases;
        if (phases && phases.length > 0 && phases[0].hold_seconds) {
            return phases[0].hold_seconds * 1000;
        }
        // Fallback: Vasalva/ULNTT 2.5 s, Bakody 1.5 s
        const id = (data.identifier || '').toLowerCase();
        if (id === 'neck_vasalva' || id.startsWith('ulntt_neck')) return 2500;
        return 1500;
    })();
    // Flag to seed EMA with the actual first-frame angle (avoids ramp-up bias
    // where EMA starting at 0 produces an underestimated calibration baseline).
    const firstFrameRef = React.useRef(true);

    // Derive maxAngle from last answer mapping entry (cap values like 181→180, 91→90)
    const answerMapping = data.cvAnswerMapping || [];
    const gaugeMaxAngle = (() => {
        if (answerMapping.length === 0) return 180;
        const lastMax = answerMapping[answerMapping.length - 1].max_angle;
        // If max_angle is just past a round number (e.g. 181, 91), cap it
        return lastMax % 10 === 1 ? lastMax - 1 : lastMax;
    })();

    // Reset when question changes
    useEffect(() => {
        setCvMode('question');
        setCvResult(null);
        setCvResultId(null);
        setIsMeasuringStarted(false);
        setCvRuntimeStatus('loading');
        setAutoStartMeasurePending(false);
        setLiveMaxAngle(0);
        setLiveCurrentAngle(0);
        smoothedAngleRef.current = 0;
        rawAngleWindowRef.current = [];
        gaugeReadyRef.current = false;
        setBestResult(null);
        setBestAutoAnswerId(null);
        setLatestAngle(null);
        setAttemptCount(0);
        setDualLeftMaxAngle(null);
        setDualRightMaxAngle(null);
        autoFilledRef.current = false;
        dualLeftMaxAngleRef.current = null;
        dualRightMaxAngleRef.current = null;
        calibrationSamplesRef.current = [];
        calibrationBaselineRef.current = null;
        torsoCalibrationSamplesRef.current = [];
        torsoCalibrationBaselineRef.current = null;
        headCalibrationSamplesRef.current = [];
        headCalibrationBaselineRef.current = null;
        sagittalWarmupCandidatesRef.current = [];
        rotationWarmupCandidatesRef.current = [];
        rotationNeutralSamplesRef.current = [];
        rotationAllSamplesRef.current = [];
        warmupStartMsRef.current = null;
        lastDirectionalAngleRef.current = null;
        firstFrameRef.current = true;
        setLiveTorsoInclination(null);
        pendingAcceptAfterSubmitRef.current = false;
        setPoseCorrect(false);
        poseCorrectSinceRef.current = null;
    }, [data && data.id]);

    // If the right-side question is reached after dual capture, auto-fill and advance.
    useEffect(() => {
        if (!isDualRightQuestion || autoFilledRef.current) return;
        try {
            const key = `cv_dual_prefill:${identifier}`;
            const raw = localStorage.getItem(key);
            if (!raw) return;
            const payload = JSON.parse(raw);
            if (payload && payload.answerId) {
                autoFilledRef.current = true;
                localStorage.removeItem(key);
                selectedChoiceCallback(payload.answerId, payload.cvResultId || null);
            }
        } catch (e) {
            console.error('[HybridCV] prefill parse error:', e);
        }
    }, [isDualRightQuestion, identifier, selectedChoiceCallback]);

    // Prepare warmup state when entering active mode.
    // Actual warmup starts on the first post-lock angle frame.
    useEffect(() => {
        if (cvMode === 'active' && isMeasure) {
            if (isDualLeftQuestion && !isMeasuringStarted) return;
            gaugeReadyRef.current = false;
            warmupStartMsRef.current = null;
            smoothedAngleRef.current = 0;
            rawAngleWindowRef.current = [];
            firstFrameRef.current = true;
            calibrationSamplesRef.current = [];
            calibrationBaselineRef.current = null;
            torsoCalibrationSamplesRef.current = [];
            torsoCalibrationBaselineRef.current = null;
            headCalibrationSamplesRef.current = [];
            headCalibrationBaselineRef.current = null;
            sagittalWarmupCandidatesRef.current = [];
            rotationWarmupCandidatesRef.current = [];
            rotationNeutralSamplesRef.current = [];
            rotationAllSamplesRef.current = [];
            setLiveMaxAngle(0);
            setLiveCurrentAngle(0);
            setLiveTorsoInclination(null);
            lastDirectionalAngleRef.current = null;
        }
    }, [cvMode, isMeasure, isDualLeftQuestion, isMeasuringStarted]);

    // Live angle callback from ComputerVisionTest — fires every frame.
    // ---- Pose-check handler (cv_pose_check mode — Bakody etc.) ----
    const handlePoseCheckUpdate = useCallback(({ poseCheck }) => {
        if (!poseCheck) return;
        const now = performance.now();
        if (poseCheck.correct) {
            if (poseCorrectSinceRef.current == null) {
                poseCorrectSinceRef.current = now;
            }
            if (now - poseCorrectSinceRef.current >= POSE_HOLD_MS && !poseCorrect) {
                setPoseCorrect(true);
            }
        } else {
            poseCorrectSinceRef.current = null;
            // NOTE: do NOT reset poseCorrect once achieved — stays green
        }
    }, [poseCorrect, POSE_HOLD_MS]);

    // EMA smoothing (alpha 0.15) prevents jitter while staying responsive.
    // For sagittal tests (flexion/extension): angles are collected during the
    // 1-second warmup and averaged to establish a neutral baseline.  All
    // subsequent ROM readings are relative to that neutral, correcting for
    // natural forward-head posture offset.
    const handleAngleUpdate = useCallback(({ angle, torsoInclination, sagittalAngles, sagittalBaselineMetrics, rotationBaselineMetrics, rotationNeutralSimilarity }) => {
        if (isDualLeftQuestion && !isMeasuringStarted) {
            return;
        }

        const raw = Number(angle) || 0;
        const windowSize = 2;
        const rawWindow = rawAngleWindowRef.current;
        rawWindow.push(raw);
        if (rawWindow.length > windowSize) rawWindow.shift();
        const averagedRaw = rawWindow.reduce((sum, v) => sum + v, 0) / rawWindow.length;

        const alpha = 0.26; // EMA smoothing factor — higher is more responsive, lower is smoother
        if (firstFrameRef.current) {
            // Seed EMA with the real first angle to avoid calibration bias from
            // the initial ramp-up when smoothedAngleRef starts at 0.
            smoothedAngleRef.current = averagedRaw;
            firstFrameRef.current = false;
        } else {
            smoothedAngleRef.current = smoothedAngleRef.current * (1 - alpha) + averagedRaw * alpha;
        }

        if (!gaugeReadyRef.current) {
            if (warmupStartMsRef.current == null) {
                warmupStartMsRef.current = performance.now();
            }
            // During warmup: collect samples for neutral calibration.
            if (isNeckFlexionSolo || isNeckExtensionSolo || isDualLeftQuestion) {
                calibrationSamplesRef.current.push(smoothedAngleRef.current);
                if (isDualLeftQuestion) {
                    rotationAllSamplesRef.current.push(smoothedAngleRef.current);
                    const similarity = Number(rotationNeutralSimilarity);
                    if (Number.isFinite(similarity) && similarity >= 0.95) {
                        rotationNeutralSamplesRef.current.push(smoothedAngleRef.current);
                    }
                    if (rotationBaselineMetrics
                        && Number.isFinite(Number(rotationBaselineMetrics.centerDeviation))
                        && Number.isFinite(Number(rotationBaselineMetrics.headLineHorizontalDeviation))
                        && Number.isFinite(Number(rotationBaselineMetrics.headHeight))) {
                        rotationWarmupCandidatesRef.current.push({
                            angle: smoothedAngleRef.current,
                            centerDeviation: Number(rotationBaselineMetrics.centerDeviation),
                            headLineHorizontalDeviation: Number(rotationBaselineMetrics.headLineHorizontalDeviation),
                            headHeight: Number(rotationBaselineMetrics.headHeight),
                        });
                    }
                }
                if ((isNeckFlexionSolo || isNeckExtensionSolo) && torsoInclination != null) {
                    torsoCalibrationSamplesRef.current.push(Number(torsoInclination));
                }
                if ((isNeckFlexionSolo || isNeckExtensionSolo)
                    && sagittalAngles
                    && Number.isFinite(Number(sagittalAngles.headAngleDeg))) {
                    headCalibrationSamplesRef.current.push(Number(sagittalAngles.headAngleDeg));
                }
                if ((isNeckFlexionSolo || isNeckExtensionSolo)
                    && sagittalAngles
                    && sagittalBaselineMetrics
                    && Number.isFinite(Number(sagittalBaselineMetrics.earNoseHorizontalDeviation))
                    && Number.isFinite(Number(sagittalBaselineMetrics.torsoVerticalDeviation))) {
                    const headDeg = Number(sagittalAngles.headAngleDeg);
                    const torsoDeg = Number.isFinite(Number(sagittalAngles.torsoAngleDeg))
                        ? Number(sagittalAngles.torsoAngleDeg)
                        : (Number(torsoInclination) || 0);
                    if (Number.isFinite(headDeg) && Number.isFinite(torsoDeg)) {
                        sagittalWarmupCandidatesRef.current.push({
                            angle: smoothedAngleRef.current,
                            headAngleDeg: headDeg,
                            torsoAngleDeg: torsoDeg,
                            earNoseHorizontalDeviation: Number(sagittalBaselineMetrics.earNoseHorizontalDeviation),
                            torsoVerticalDeviation: Number(sagittalBaselineMetrics.torsoVerticalDeviation),
                        });
                    }
                }
            }
            if (performance.now() - warmupStartMsRef.current < 1500) {
                return;
            }
            gaugeReadyRef.current = true;
        }

        // First active frame: compute baseline from warmup samples.
        if ((isNeckFlexionSolo || isNeckExtensionSolo || isDualLeftQuestion) && calibrationBaselineRef.current === null) {
            const samples = calibrationSamplesRef.current;
            if (samples.length === 0) {
                calibrationBaselineRef.current = smoothedAngleRef.current;
            } else if (isNeckFlexionSolo || isNeckExtensionSolo) {
                // For sagittal tests, choose the warmup frame closest to:
                // 1) ear-nose horizontal line and 2) hip-shoulder vertical line.
                const candidates = sagittalWarmupCandidatesRef.current;
                if (candidates.length > 0) {
                    let best = candidates[0];
                    let bestScore = Number.POSITIVE_INFINITY;
                    for (let i = 0; i < candidates.length; i += 1) {
                        const c = candidates[i];
                        // Favor torso-upright slightly more to avoid trunk-lean baseline skew.
                        const score = (1.15 * c.torsoVerticalDeviation) + c.earNoseHorizontalDeviation;
                        if (score < bestScore) {
                            bestScore = score;
                            best = c;
                        }
                    }
                    calibrationBaselineRef.current = best.angle;
                    torsoCalibrationBaselineRef.current = best.torsoAngleDeg;
                    headCalibrationBaselineRef.current = best.headAngleDeg;
                } else {
                    // Fallback path if quality metrics are unavailable.
                    calibrationBaselineRef.current = Math.max(...samples);

                    const torsoSamples = torsoCalibrationSamplesRef.current;
                    if (torsoSamples.length > 0) {
                        let peakIdx = 0;
                        let peakVal = samples[0];
                        for (let i = 1; i < samples.length; i += 1) {
                            if (samples[i] > peakVal) {
                                peakVal = samples[i];
                                peakIdx = i;
                            }
                        }
                        const torsoAtPeak = torsoSamples[Math.min(peakIdx, torsoSamples.length - 1)];
                        torsoCalibrationBaselineRef.current = Number.isFinite(torsoAtPeak)
                            ? torsoAtPeak
                            : torsoSamples.reduce((a, b) => a + b, 0) / torsoSamples.length;
                    }

                    const headSamples = headCalibrationSamplesRef.current;
                    if (headSamples.length > 0) {
                        let peakIdx = 0;
                        let peakVal = samples[0];
                        for (let i = 1; i < samples.length; i += 1) {
                            if (samples[i] > peakVal) {
                                peakVal = samples[i];
                                peakIdx = i;
                            }
                        }
                        const headAtPeak = headSamples[Math.min(peakIdx, headSamples.length - 1)];
                        headCalibrationBaselineRef.current = Number.isFinite(headAtPeak)
                            ? headAtPeak
                            : headSamples.reduce((a, b) => a + b, 0) / headSamples.length;
                    }
                }
            } else if (isDualLeftQuestion) {
                // Rotation neutral baseline: choose frames closest to centered upright neutral.
                // Criteria:
                // 1) head midpoint near shoulder vertical centerline
                // 2) nose-earMid line near horizontal
                // 3) taller posture preferred
                const candidates = rotationWarmupCandidatesRef.current;
                if (candidates.length > 0) {
                    const scored = candidates
                        .map((c) => ({
                            c,
                            score: (1.30 * c.centerDeviation) + c.headLineHorizontalDeviation - (0.40 * c.headHeight),
                        }))
                        .sort((a, b) => a.score - b.score);
                    const topN = Math.max(1, Math.min(5, scored.length));
                    const baselinePool = scored.slice(0, topN).map((s) => s.c.angle);
                    calibrationBaselineRef.current = baselinePool.reduce((a, b) => a + b, 0) / baselinePool.length;
                } else {
                    // Fallback: prefer warmup frames where nose->left/right ear are near-symmetric.
                    const neutral = rotationNeutralSamplesRef.current;
                    const all = rotationAllSamplesRef.current.length > 0
                        ? rotationAllSamplesRef.current
                        : samples;
                    const baselinePool = neutral.length >= 5 ? neutral : all;
                    calibrationBaselineRef.current = baselinePool.reduce((a, b) => a + b, 0) / baselinePool.length;
                }
            } else {
                calibrationBaselineRef.current = samples.reduce((a, b) => a + b, 0) / samples.length;
            }
        }

        // Subtract the neutral baseline so the angle is truly
        // ROM from neutral (not absolute screen-space angle).
        const calibrationOffset = (isNeckFlexionSolo || isNeckExtensionSolo || isDualLeftQuestion)
            ? (calibrationBaselineRef.current ?? 0)
            : 0;

        const calibrated = smoothedAngleRef.current - calibrationOffset;
        const smoothed = Math.round(calibrated);
        // Keep sagittal directions isolated so flexion max never captures extension.
        const directionalAngle = isNeckFlexionSolo
            ? Math.max(0, -calibrated)
            : (isNeckExtensionSolo ? Math.max(0, calibrated) : calibrated);
        setLiveCurrentAngle(Math.round(directionalAngle));

        const previousDirectional = lastDirectionalAngleRef.current;
        const frameDelta = previousDirectional == null ? 0 : (directionalAngle - previousDirectional);
        lastDirectionalAngleRef.current = directionalAngle;
        const acceleratingUp = frameDelta > 0;
        const jumpTooFast = acceleratingUp && frameDelta > 10;
        const highAngleJump = acceleratingUp && directionalAngle >= 90 && frameDelta > 10;
        const faultyAcceleration = jumpTooFast || highAngleJump;
        // Update live torso inclination for sagittal tests (EMA smoothed, 1 decimal)
        if ((isNeckFlexionSolo || isNeckExtensionSolo) && torsoInclination != null) {
            const torsoBaseline = torsoCalibrationBaselineRef.current ?? 0;
            const relativeTorso = Number(torsoInclination) - torsoBaseline;
            setLiveTorsoInclination(Math.round(relativeTorso * 10) / 10);
        }

        let isFlexionMotionValid = true;
        if (isNeckFlexionSolo && sagittalAngles) {
            const headNow = Number(sagittalAngles.headAngleDeg);
            const torsoNow = Number.isFinite(Number(sagittalAngles.torsoAngleDeg))
                ? Number(sagittalAngles.torsoAngleDeg)
                : (Number(torsoInclination) || 0);
            const headBaseline = headCalibrationBaselineRef.current;
            const torsoBaseline = torsoCalibrationBaselineRef.current;

            if (Number.isFinite(headNow) && Number.isFinite(headBaseline) && Number.isFinite(torsoBaseline)) {
                const relativeHead = headNow - headBaseline;
                const relativeTorso = torsoNow - torsoBaseline;
                const headMagnitude = Math.abs(relativeHead);
                const torsoMagnitude = Math.abs(relativeTorso);
                const neckVsTorso = headMagnitude - 0.85 * torsoMagnitude;

                // Guard against counting pure trunk lean as neck flexion:
                // require meaningful head movement and a net neck contribution.
                const headMovedEnough = headMagnitude >= 3;
                const netNeckMovedEnough = neckVsTorso >= 2;
                const torsoDominates = torsoMagnitude > headMagnitude * 1.35;
                isFlexionMotionValid = headMovedEnough && netNeckMovedEnough && !torsoDominates;
            }
        }

        // Direction-filtered max: sagittal tests only capture the relevant direction.
        if (isNeckFlexionSolo) {
            if (directionalAngle > 0 && !faultyAcceleration && isFlexionMotionValid) {
                setLiveMaxAngle(prev => Math.max(prev, directionalAngle));
            }
        } else if (isNeckExtensionSolo) {
            // neck_extension calculator returns positive for extension
            if (directionalAngle > 0 && !faultyAcceleration) {
                setLiveMaxAngle(prev => Math.max(prev, directionalAngle));
            }
        } else {
            if (!faultyAcceleration) {
                setLiveMaxAngle(prev => Math.max(prev, Math.abs(directionalAngle)));
            }
        }
        // For dual-question tests, track each direction's max independently.
        // Runtime sign convention here is negative=LEFT and positive=RIGHT.
        if (isDualLeftQuestion) {
            if (smoothed < 0) {
                const absLeft = -smoothed;
                if (dualLeftMaxAngleRef.current == null || absLeft > dualLeftMaxAngleRef.current) {
                    dualLeftMaxAngleRef.current = absLeft;
                }
                setDualLeftMaxAngle(prev => (prev == null || absLeft > prev) ? absLeft : prev);
            } else if (smoothed > 0) {
                if (dualRightMaxAngleRef.current == null || smoothed > dualRightMaxAngleRef.current) {
                    dualRightMaxAngleRef.current = smoothed;
                }
                setDualRightMaxAngle(prev => (prev == null || smoothed > prev) ? smoothed : prev);
            }
        }
    }, [isDualLeftQuestion, isNeckFlexionSolo, isNeckExtensionSolo, isMeasuringStarted]);

    const mapAngleToAnswer = useCallback((angleAbs) => {
        if (!answerMapping || answerMapping.length === 0) return null;
        const match = answerMapping.find(m => angleAbs >= m.min_angle && angleAbs < m.max_angle);
        return match ? match.answer_id : null;
    }, [answerMapping]);

    // Derive live auto-answer from live max angle for real-time display
    const liveAutoAnswerId = useMemo(() => {
        if (!isMeasure || answerMapping.length === 0 || !liveMaxAngle) return null;
        const match = answerMapping.find(m => liveMaxAngle >= m.min_angle && liveMaxAngle < m.max_angle);
        return match ? match.answer_id : null;
    }, [isMeasure, answerMapping, liveMaxAngle]);

    const liveMatchedText = useMemo(() => {
        if (!liveAutoAnswerId || !data.answers) return null;
        const ans = data.answers.find(a => a.answerId === liveAutoAnswerId || a.id === liveAutoAnswerId);
        return ans ? (ans.answerText || ans.text) : null;
    }, [liveAutoAnswerId, data.answers]);

    // Save CV result to backend, returns the result_id
    const saveCvResult = async (resultData, sideOverride = null) => {
        const token = localStorage.getItem('token');
        if (!token || !data.assessmentId) return null; // skip for open/unauthenticated assessments
        try {
            const resp = await fetch('https://api.virtus-one.com/question-handler/cv-test/validate/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Token ${token}`,
                },
                body: JSON.stringify({
                    assessment_id: data.assessmentId || '',
                    question_id: data.id,
                    test_definition_id: data.cvTestConfig?.testDefinitionId,
                    side: sideOverride || data.cvSide || 'left',
                    landmark_frames: resultData.landmarkFrames || [],
                }),
            });
            if (resp.ok) {
                const srv = await resp.json();
                return srv.result_id || null;
            }
        } catch (e) {
            console.error('[HybridCV] save error:', e);
        }
        return null;
    };

    const finalizeMeasurementAcceptance = useCallback(async (resultDataOverride = null) => {
        const resultPayload = resultDataOverride || cvResult || {};

        if (isDualLeftQuestion) {
            const leftMax = dualLeftMaxAngleRef.current;
            const rightMax = dualRightMaxAngleRef.current;
            const leftAnswerId = leftMax != null ? mapAngleToAnswer(leftMax) : null;
            const rightAnswerId = rightMax != null ? mapAngleToAnswer(rightMax) : null;
            if (!leftAnswerId || !rightAnswerId) return;

            const [leftSavedId, rightSavedId] = await Promise.all([
                saveCvResult(resultPayload, 'left'),
                saveCvResult(resultPayload, 'right'),
            ]);
            if (rightIdentifier) {
                localStorage.setItem(`cv_dual_prefill:${rightIdentifier}`, JSON.stringify({
                    answerId: rightAnswerId,
                    cvResultId: rightSavedId,
                }));
            }
            selectedChoiceCallback(leftAnswerId, leftSavedId);
            return;
        }

        const answerId = bestAutoAnswerId || liveAutoAnswerId;
        if (!answerId) return;
        const savedId = await saveCvResult(resultPayload);
        selectedChoiceCallback(answerId, savedId || cvResultId);
    }, [
        cvResult,
        isDualLeftQuestion,
        mapAngleToAnswer,
        saveCvResult,
        rightIdentifier,
        selectedChoiceCallback,
        bestAutoAnswerId,
        liveAutoAnswerId,
        cvResultId,
    ]);

    const pendingAcceptAfterSubmitRef = React.useRef(false);

    const handleCvComplete = async (resultData, autoAnswerId) => {
        setCvResult(resultData);

        if (isMeasure) {
            const newAngle = resultData.maxAngleReached || 0;
            setLatestAngle(newAngle);
            setAttemptCount(prev => prev + 1);

            if (!isFreeMeasureFlow) {
                // Update best if this attempt is higher (or first attempt)
                if (!bestResult || newAngle > (bestResult.maxAngleReached || 0)) {
                    setBestResult(resultData);
                    setBestAutoAnswerId(autoAnswerId);
                }

                // Save in background (don't block UI)
                saveCvResult(resultData).then(id => {
                    if (!bestResult || newAngle > (bestResult.maxAngleReached || 0)) {
                        setCvResultId(id);
                    }
                });
            }

            if (pendingAcceptAfterSubmitRef.current) {
                pendingAcceptAfterSubmitRef.current = false;
                await finalizeMeasurementAcceptance(resultData);
            }
        } else {
            // cv_guided — movement validated, now show answer cards
            setCvMode('validated');
            // Save validation result in background
            saveCvResult(resultData).then(id => setCvResultId(id));
        }
    };

    // Accept the best measurement and advance the question
    const handleAcceptMeasurement = async () => {
        if (isDualLeftQuestion && !isMeasuringStarted) {
            setCvResult(null);
            setLiveMaxAngle(0);
            setLiveCurrentAngle(0);
            setDualLeftMaxAngle(null);
            setDualRightMaxAngle(null);
            dualLeftMaxAngleRef.current = null;
            dualRightMaxAngleRef.current = null;
            smoothedAngleRef.current = 0;
            gaugeReadyRef.current = false;
            firstFrameRef.current = true;
            calibrationSamplesRef.current = [];
            calibrationBaselineRef.current = null;
            setLiveTorsoInclination(null);
            setIsMeasuringStarted(true);
            return;
        }

        if (isFreeMeasureFlow && !cvResult) {
            pendingAcceptAfterSubmitRef.current = true;
            setManualSubmitSignal(prev => prev + 1);
            return;
        }
        await finalizeMeasurementAcceptance();
    };

    useEffect(() => {
        if (!isDualLeftQuestion || !autoStartMeasurePending) return;
        if (cvRuntimeStatus !== 'running') return;

        setCvResult(null);
        setLiveMaxAngle(0);
        setLiveCurrentAngle(0);
        setDualLeftMaxAngle(null);
        setDualRightMaxAngle(null);
        dualLeftMaxAngleRef.current = null;
        dualRightMaxAngleRef.current = null;
        smoothedAngleRef.current = 0;
        gaugeReadyRef.current = false;
        firstFrameRef.current = true;
        calibrationSamplesRef.current = [];
        calibrationBaselineRef.current = null;
        setLiveTorsoInclination(null);
        setIsMeasuringStarted(true);
        setAutoStartMeasurePending(false);
    }, [isDualLeftQuestion, autoStartMeasurePending, cvRuntimeStatus]);

    // Arm auto-start whenever the dual-rotation flow is active and not yet measuring.
    // This covers both "Use Camera Test" entry and default active-first rendering.
    useEffect(() => {
        if (!isDualLeftQuestion) return;
        if (cvMode !== 'active') return;
        if (isMeasuringStarted) return;
        if (autoStartMeasurePending) return;
        setAutoStartMeasurePending(true);
    }, [isDualLeftQuestion, cvMode, isMeasuringStarted, autoStartMeasurePending]);

    // Wrap callback to attach cvResultId when patient picks a card after CV
    const handleCardSelect = (answerId) => {
        selectedChoiceCallback(answerId, cvResultId);
    };

    // Look up matched answer text for display (best result or live)
    const matchedAnswerText = (() => {
        const aid = bestAutoAnswerId || liveAutoAnswerId;
        if (!aid || !data.answers) return null;
        const ans = data.answers.find(a => a.answerId === aid || a.id === aid);
        return ans ? (ans.answerText || ans.text) : null;
    })();

    // Determine which angle values to display on gauge
    const maxAbsAngle = bestResult ? Math.max(bestResult.maxAngleReached || 0, liveMaxAngle) : liveMaxAngle;
    const displayCurrentAngle = centeredRotationGauge ? liveCurrentAngle : Math.abs(liveCurrentAngle);
    // For dual mode: needle shows the current live signed angle so both sides are visible.
    // For single-side: use signed max pointing in the correct direction.
    const displayMaxAngle = centeredRotationGauge
        ? (isDualLeftQuestion
            ? liveCurrentAngle
            : ((data.cvSide === 'right' ? 1 : -1) * maxAbsAngle))
        : maxAbsAngle;
    const displayLeftMax = isDualLeftQuestion ? (dualLeftMaxAngle || null) : null;
    const displayRightMax = isDualLeftQuestion ? (dualRightMaxAngle || null) : null;

    const activeCvData = useMemo(() => {
        if (!isDualLeftQuestion) return data;
        return {
            ...data,
            cvSide: 'left',
            cvInstructions: 'Sit upright facing the camera. Rotate your head LEFT then RIGHT as far as comfortable.',
        };
    }, [data, isDualLeftQuestion]);

    const resetDualRotationMeasurement = useCallback(() => {
        if (!isDualLeftQuestion) return;
        setIsMeasuringStarted(false);
        setCvRuntimeStatus('loading');
        setAutoStartMeasurePending(false);
        setCvResult(null);
        setLiveMaxAngle(0);
        setLiveCurrentAngle(0);
        setDualLeftMaxAngle(null);
        setDualRightMaxAngle(null);
        dualLeftMaxAngleRef.current = null;
        dualRightMaxAngleRef.current = null;
        smoothedAngleRef.current = 0;
        gaugeReadyRef.current = false;
        firstFrameRef.current = true;
        calibrationSamplesRef.current = [];
        calibrationBaselineRef.current = null;
        setLiveTorsoInclination(null);
        pendingAcceptAfterSubmitRef.current = false;
    }, [isDualLeftQuestion]);

    const handleUseCameraTest = useCallback(() => {
        resetDualRotationMeasurement();
        if (isDualLeftQuestion) {
            setAutoStartMeasurePending(true);
        }
        setCvMode('active');
    }, [resetDualRotationMeasurement, isDualLeftQuestion]);

    const handleSkipCameraTest = useCallback(() => {
        resetDualRotationMeasurement();
        setCvMode('offer');
    }, [resetDualRotationMeasurement]);

    const showMeasureAction = isMeasure && (
        isDualLeftQuestion
            ? cvMode === 'active'
            : ((isFreeMeasureFlow && !cvResult) || (bestAutoAnswerId || liveAutoAnswerId))
    );

    const showCamera = cvMode === 'active';
    const showAnswerCards = cvMode === 'offer' || cvMode === 'validated'
        || (isPoseCheck && cvMode === 'active' && poseCorrect);

    return (
        <Grid container direction="column" style={{ margin: 0, marginTop: -5, padding: 20 }}>
            {/* ---- Question title — always visible ---- */}
            <Typography
                variant="h5"
                className={data.questionClassName || ""}
                style={{ color: '#002D55', maxWidth: 800, whiteSpace: 'break-spaces', marginBottom: 20 }}
            >
                <TypingText text={data.title} speed={0} />
            </Typography>

            {/* ---- Media frame: picture or camera feed ---- */}
            <div style={{ position: 'relative', alignSelf: 'center', maxWidth: 500, width: '100%', marginBottom: 12 }}>
                {/* Static picture (question / validated states) */}
                {!showCamera && data.pictureUrl && (
                    <img
                        src={data.pictureUrl}
                        alt="question"
                        style={{
                            width: '100%',
                            maxHeight: '50vh',
                            objectFit: 'contain',
                            borderRadius: 16,
                            display: 'block',
                        }}
                    />
                )}

                {/* "Guide with Camera" overlay button on the picture */}
                {cvMode === 'question' && data.pictureUrl && (
                    <div style={{
                        position: 'absolute',
                        bottom: 20,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 2,
                    }}>
                        <Button
                            variant="contained"
                            size="large"
                            style={{
                                backgroundColor: '#002D55',
                                color: '#fff',
                                borderRadius: 24,
                                padding: '10px 32px',
                                fontSize: 16,
                                fontWeight: 600,
                                textTransform: 'none',
                                boxShadow: '0 4px 16px rgba(0,45,85,0.35)',
                            }}
                            onClick={() => setCvMode('active')}
                        >
                            Guide with Camera
                        </Button>
                    </div>
                )}

                {/* No picture — standalone button */}
                {cvMode === 'question' && !data.pictureUrl && (
                    <div style={{ textAlign: 'center', marginTop: 16 }}>
                        <Button
                            variant="contained"
                            size="large"
                            style={{
                                backgroundColor: '#002D55',
                                color: '#fff',
                                borderRadius: 24,
                                padding: '10px 32px',
                                fontSize: 16,
                                fontWeight: 600,
                                textTransform: 'none',
                            }}
                            onClick={() => setCvMode('active')}
                        >
                            Guide with Camera
                        </Button>
                    </div>
                )}

                {/* Camera feed — replaces picture in the same frame */}
                {showCamera && (
                    <ComputerVisionTest
                        key={data.id}
                        data={activeCvData}
                        selectedChoiceCallback={selectedChoiceCallback}
                        embedded
                        onCvComplete={handleCvComplete}
                        onAngleUpdate={isPoseCheck ? handlePoseCheckUpdate : (isMeasure ? handleAngleUpdate : undefined)}
                        freeMeasure={isPoseCheck ? true : isFreeMeasureFlow}
                        autoStartSignal="auto"
                        onStatusChange={setCvRuntimeStatus}
                        manualSubmitSignal={manualSubmitSignal}
                        embeddedOverlayContent={isMeasure ? (
                            <Paper elevation={2} style={{
                                transform: 'scale(0.69)',
                                transformOrigin: 'bottom center',
                                width: 'min(320px, 84%)',
                                padding: '6px 8px 5px',
                                textAlign: 'center',
                                border: '1px solid rgba(0,45,85,0.28)',
                                borderRadius: 14,
                                backgroundColor: 'rgba(255,255,255,0.78)',
                                backdropFilter: 'blur(2px)',
                                pointerEvents: 'none',
                                marginBottom: -14,
                            }}>
                                {isDualLeftQuestion && (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: 6,
                                        marginBottom: 0,
                                        fontSize: 16,
                                        color: '#002D55',
                                        fontWeight: 600,
                                    }}>
                                        <span>Left max: {displayLeftMax != null ? `${displayLeftMax}°` : '—'}</span>
                                        <span>Right max: {displayRightMax != null ? `${displayRightMax}°` : '—'}</span>
                                    </div>
                                )}
                                <div style={{ marginTop: -30, marginBottom: -3 }}>
                                    <AngleGauge
                                        currentAngle={displayCurrentAngle}
                                        bestAngle={displayMaxAngle}
                                        maxAngle={gaugeMaxAngle}
                                        answerMapping={answerMapping}
                                        normalRange={data.cvTestConfig?.normalRange || null}
                                        centeredZero={centeredRotationGauge}
                                    />
                                </div>
                                {matchedAnswerText && (
                                    <Typography variant="body1" style={{
                                        color: '#002D55',
                                        fontWeight: 600,
                                        marginTop: 8,
                                    }}>
                                    </Typography>
                                )}
                            </Paper>
                        ) : null}
                    />
                )}

                {/* Validated banner overlaid on picture */}
                {cvMode === 'validated' && data.pictureUrl && (
                    <div style={{
                        position: 'absolute',
                        top: 12,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 2,
                        backgroundColor: 'rgba(240,247,230,0.92)',
                        borderRadius: 12,
                        padding: '8px 20px',
                        textAlign: 'center',
                        backdropFilter: 'blur(4px)',
                    }}>
                        <Typography variant="body1" style={{ color: '#2e7d32', fontWeight: 600 }}>
                            ✓ Movement test completed
                        </Typography>
                        {cvResult && cvResult.maxAngleReached != null && (
                            <Typography variant="body2" color="textSecondary">
                                Range achieved: {cvResult.maxAngleReached}°
                            </Typography>
                        )}
                    </div>
                )}
            </div>

            {/* ---- Action buttons below frame ---- */}
            {showCamera && showMeasureAction && (
                <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 0, marginBottom: 8 }}>
                    <Button
                        variant="contained"
                        size="medium"
                        className={classes.button2}
                        onClick={handleAcceptMeasurement}
                    >
                        {isDualLeftQuestion && !isMeasuringStarted ? 'Preparing measurement...' : 'Accept Measurement'}
                    </Button>
                    <Button
                        variant="text"
                        size="small"
                        style={{ color: '#888' }}
                        onClick={handleSkipCameraTest}
                    >
                        Skip camera test
                    </Button>
                </div>
            )}

            {/* ---- Pose check indicator (cv_pose_check, camera active) ---- */}
            {showCamera && isPoseCheck && (
                <>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                        marginTop: 12,
                        marginBottom: poseCorrect ? 16 : 0,
                        transition: 'margin-bottom 400ms ease',
                    }}>
                        {poseCorrect && (
                            <span style={{
                                color: '#4caf50',
                                fontSize: 28,
                                lineHeight: 1,
                                fontWeight: 700,
                                animation: 'poseCheckPop 350ms ease',
                            }}>✓</span>
                        )}
                        <Typography variant="h6" style={{
                            color: poseCorrect ? '#4caf50' : '#9e9e9e',
                            fontWeight: 600,
                            transition: 'color 400ms ease',
                        }}>
                            Posture correct
                        </Typography>
                    </div>
                    {!poseCorrect && (
                        <div style={{ textAlign: 'center', marginTop: 4 }}>
                            <Button
                                variant="text"
                                size="small"
                                style={{ color: '#888' }}
                                onClick={handleSkipCameraTest}
                            >
                                Skip camera test
                            </Button>
                        </div>
                    )}
                    <style>{`
                        @keyframes poseCheckPop {
                            0% { transform: scale(0); opacity: 0; }
                            60% { transform: scale(1.3); }
                            100% { transform: scale(1); opacity: 1; }
                        }
                        @keyframes poseCardsFadeIn {
                            from { opacity: 0; transform: translateY(12px); }
                            to   { opacity: 1; transform: translateY(0); }
                        }
                    `}</style>
                </>
            )}

            {/* Skip camera link (question state) */}
            {cvMode === 'question' && (
                <div style={{ textAlign: 'center', marginTop: 4 }}>
                    <Button
                        variant="text"
                        size="small"
                        style={{ color: '#888' }}
                        onClick={() => setCvMode('offer')}
                    >
                        Skip camera test
                    </Button>
                </div>
            )}

            {/* ---- Answer cards (shown after pose correct, skip, or validated) ---- */}
            {showAnswerCards && (
                <div style={{ animation: 'poseCardsFadeIn 500ms ease', marginTop: 8 }}>
                    {(cvMode === 'validated' || (isPoseCheck && poseCorrect)) && (
                        <Typography variant="body2" style={{ textAlign: 'center', color: '#555', marginBottom: 10 }}>
                            Now select the option that best describes your experience:
                        </Typography>
                    )}
                    <MultipleChoiceComp
                        data={{
                            ...data,
                            title: '',
                            pictureUrl: null,
                        }}
                        selectedChoiceCallback={cvMode === 'validated' ? handleCardSelect : selectedChoiceCallback}
                        styleComp={styleComp}
                    />
                    <style>{`
                        @keyframes poseCardsFadeIn {
                            from { opacity: 0; transform: translateY(12px); }
                            to   { opacity: 1; transform: translateY(0); }
                        }
                    `}</style>
                </div>
            )}
        </Grid>
    );
}

 /*

    */

function DropDownComp({ data, selectedChoiceCallback, styleComp }) {
    const [selectedId, setSelectedId] = useState("");

    // Reset selectedId when question changes
    useEffect(() => {
        setSelectedId("");
    }, [data.id]);

    const handleChange = (event) => {
        setSelectedId(event.target.value);
        selectedChoiceCallback(event.target.value);
    };

    return (
        <Grid container direction="column" className={styleComp.root}>
            <InputLabel>
                <Typography
                    variant="h5"
                    className={data.questionClassName || ""}
                    style={{ color: "#002D55", marginBottom: "5%", maxWidth: 800 }}
                >
                    <TypingText text={data.title} speed={0} />
                </Typography>
            </InputLabel>
            <InputLabel>
                <span style={{ color: "#002D55", marginLeft: 1 }}>Click to select answer:</span>
            </InputLabel>
            <Select
                input={<Input name="searchCriteria" id="searchCriteria" />}
                onChange={handleChange}
                value={selectedId}
                style={{
                    minWidth: 50,
                    backgroundColor: selectedId ? "#002D55" : "#fff",
                    color: selectedId ? "#fff" : "#002D55"
                }}
            >
                {data.answers.map((item) => (
                    <MenuItem
                        key={item.answerId}
                        value={item.answerId}
                        style={{
                            backgroundColor: selectedId === item.answerId ? "#002D55" : "#fff",
                            color: selectedId === item.answerId ? "#fff" : "#002D55"
                        }}
                    >
                        {item.answerText}
                    </MenuItem>
                ))}
            </Select>
        </Grid>
    );
}

// --- Patient-Specific Functional Scale / Self-rated sliders ---
const sliderMarks = [
    { value: 0, label: '0' },
    { value: 30, label: '30' },
    { value: 40, label: '40' },
    { value: 50, label: '50' },
    { value: 60, label: '60' },
    { value: 70, label: '70' },
    { value: 100, label: '100' },
];


function sliderValueText(value) {
    return `${value}`;
}

function sliderValueLabelFormat(value) {
    return value;
}

function ValueLabelComponent(props) {
    const { children, value } = props;
    return (
        <Tooltip enterTouchDelay={0} placement="top" title={value}>
            {children}
        </Tooltip>
    );
}

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.number.isRequired,
};

const PrettoSliderFunction = styled(Slider)(({ theme }) => ({
    color: '#ffffff',
    height: 5,
    margin: 8,
    paddingLeft: 6.5,
    width: '97%',
    '& .MuiSlider-thumb': {
        height: 22,
        width: 22,
        backgroundColor: '#fff',
        border: '2px solid #fb741a',
        marginTop: -10,
        marginLeft: -12,
        '&:focus, &:hover, &.Mui-active': {
            boxShadow: 'inherit',
        },
    },
    '& .MuiSlider-valueLabel': {
        left: 'calc(-25% + 0px)',
        color: '#1a90ff',
    },
    '& .MuiSlider-track': {
        height: 15,
        borderRadius: 4,
        opacity: 0.01,
    },
    '& .MuiSlider-rail': {
        height: 15,
        borderRadius: 10,
        // Reversed compared to PrettoSliderPain: make left (0) red and right (100) green
        background: 'linear-gradient(90deg, #FF0000 25%, #17aa2d 90%)',
        margin: -6,
    },
    '& .MuiSlider-markLabel': {
        fontWeight: 400,
        color: '#002D55',
    },
}));

const PrettoSliderPain = styled(Slider)(({ theme }) => ({
    color: '#ffffff',
    height: 5,
    marginLeft: 8,
    width: '95%',
    '& .MuiSlider-thumb': {
        height: 22,
        width: 22,
        backgroundColor: '#fff',
        border: '2px solid #fb741a',
        marginTop: -10,
        marginLeft: -12,
        '&:focus, &:hover, &.Mui-active': {
            boxShadow: 'inherit',
        },
    },
    '& .MuiSlider-valueLabel': {
        left: 'calc(-25% + 0px)',
        color: '#1a90ff',
    },
    '& .MuiSlider-track': {
        height: 15,
        borderRadius: 4,
        opacity: 0.01,
    },
    '& .MuiSlider-rail': {
        height: 15,
        borderRadius: 10,
        background: 'linear-gradient(90deg, #17aa2d 25%, #FF0000 90%)',
        margin: -6,
    },
    '& .MuiSlider-markLabel': {
        fontWeight: 400,
        color: '#002D55',
    },
}));

function FrequencySliderComp({ data, selectedChoiceCallback, styleComp }) {
    const classes = useStyles();
    const [value, setValue] = useState(data && data.defaultValue ? data.defaultValue : 1);
    const [pendingValue, setPendingValue] = useState(null);
    const isMobile = useMediaQuery('(max-width:600px)');

    useEffect(() => {
        setValue(data && data.defaultValue ? data.defaultValue : 1);
        setPendingValue(null);
    }, [data && data.id]);

    const handleConfirm = () => {
        if (pendingValue !== null) {
            // keep backward compatibility: send string
            selectedChoiceCallback(String(pendingValue));
            setPendingValue(null);
        }
    };

    const marks = [
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5' },
        { value: 6, label: '6' },
        { value: 7, label: '7 (daily)' }
    ];

    return (
        <Grid container direction="column" style={{ padding: 10 }}>
            <Typography
                variant={isMobile ? 'subtitle1' : 'h6'}
                className={data.questionClassName || ""}
                style={{ color: '#002D55', maxWidth: isMobile ? '100%' : 900, whiteSpace: 'break-spaces' }}
            >
                <TypingText text={(data && (data.title || data.question)) || 'How many days per week do you experience these symptoms?'} speed={0} />
            </Typography>
            <Grid container direction="column" style={{ padding: 8, marginTop: 8, maxWidth: 900 }}>
                <Grid container justify="space-between" style={{ marginTop: 6, paddingLeft: 4, paddingRight: 2 }}>
                    <Typography variant="caption">Once</Typography>
                    <Typography variant="caption">some days</Typography>
                    <Typography variant="caption">most days</Typography>
                    <Typography variant="caption">Daily</Typography>
                </Grid>
                {/*<Typography variant="body2" style={{ color: '#666' }}>{data && data.description ? data.description : 'Move the slider to choose how many days per week (1–7).'}</Typography>*/}
                <PrettoSliderPain
                    aria-labelledby="frequency-slider"
                    defaultValue={value}
                    value={value}
                    onChange={(e, v) => setValue(v)}
                    onChangeCommitted={(e, v) => setPendingValue(v)}
                    step={1}
                    min={1}
                    max={7}
                    marks={marks}
                    valueLabelDisplay="on"
                />
                {/*{pendingValue === 7 ? (
                    <Typography variant="caption" style={{ color: '#002D55', marginTop: 8 }}>
                        You selected daily — a short follow-up question may appear to clarify how often during a day.
                    </Typography>
                ) : null}*/}
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center', marginTop: 12 }}>
                <Button
                    variant="contained"
                    disabled={pendingValue === null}
                    onClick={handleConfirm}
                    className={`${classes.confirmButton} ${pendingValue !== null ? classes.confirmPending : ''}`}
                >
                    {pendingValue === null ? 'Confirm' : `Confirm (${pendingValue})`}
                </Button>
            </Grid>
        </Grid>
    );
}

function SelfRatedFunctionComp({ data, selectedChoiceCallback, styleComp }) {
    const classes = useStyles();
    const isMobile = useMediaQuery('(max-width:600px)');
    const initialDefaultValue = data && data.defaultValue ? Number(data.defaultValue) : 0;
    const [initialValue, setInitialValue] = useState(initialDefaultValue);
    const [value, setValue] = useState(initialDefaultValue);
    const [pendingValue, setPendingValue] = useState(null);
    const [description, setDescription] = useState(data && data.description ? data.description : "");
    const MIN_DESC = 10;
    const MAX_DESC = 50;

    useEffect(() => {
        const nextInitialValue = data && data.defaultValue ? Number(data.defaultValue) : 0;
        setInitialValue(nextInitialValue);
        setValue(nextInitialValue);
        setPendingValue(null);
        setDescription(data && data.description ? data.description : "");
    }, [data && data.id]);

    const handleConfirm = () => {
        const descLen = (description || '').trim().length;
        if (pendingValue !== null && pendingValue !== initialValue && descLen > MIN_DESC && descLen <= MAX_DESC) {
            // send an object so backend add_answers_to_assessment will store numeric_value and text_value
            const payload = { value: pendingValue, description: description.trim(), text: description.trim() };
            {/**console.log('SelfRatedFunction payload ->', payload);**/}
            selectedChoiceCallback(payload);
            // clear pending after confirming
            setPendingValue(null);
        }
    };

    return (
        <Grid container direction="column" style={{ padding: 10 }}>
            <Typography
                variant={isMobile ? 'subtitle1' : 'h6'}
                className={data.questionClassName || ""}
                style={{
                    color: '#002D55',
                    maxWidth: isMobile ? '100%' : 900,
                    whiteSpace: 'break-spaces',
                }}
            >
                <TypingText text={data && data.title ? data.title : 'From 0-100, rate your ability for this activity'} speed={0} />
            </Typography>
            <Grid container direction="column" style={{ padding: 2, marginTop: 14, maxWidth: 900 }}>
                {/* Highlighted display box with inline edit to make description more prominent and gamified */}
                {/** If editing, show a large textarea; otherwise show a stylized card with the description and Edit button **/}
                {/** Default to editing mode if there's no existing description (follow-up prefill may supply one) **/}
                <HighlightedDescription
                    description={description}
                    placeholder={data && data.descriptionPlaceholder ? data.descriptionPlaceholder : 'Describe the activity you have difficulty with'}
                    minLen={MIN_DESC}
                    maxLen={MAX_DESC}
                    onChange={(val) => setDescription(val)}
                    classes={classes}
                />
                {/*
                <TextField
                    description={description}
                    placeholder={data && data.descriptionPlaceholder ? data.descriptionPlaceholder : 'Describe the activity you have difficulty with'}
                    minLen={MIN_DESC}
                    maxLen={MAX_DESC}
                    onChange={(val) => setDescription(val)}
                    variant="outlined"
                    className={classes.orangeFocused}
                />*/}
            </Grid>
            <Grid container direction="column">
                    <Typography
                        variant={isMobile ? 'subtitle1' : 'h6'}
                        className={data.questionClassName || ""}
                        style={{
                            color: '#002D55',
                            marginTop: isMobile ? 14 : 25,
                            marginLeft: isMobile ? 0 : 4,
                            maxWidth: isMobile ? '100%' : undefined,
                        }}
                    >
                        Rate how able you are to perform this activity:
                    </Typography>
                <Grid container justify="space-between" style={{ marginTop: 6, paddingLeft: 4, paddingRight: 2 }}>
                    <Typography variant="caption">unable</Typography>
                    <Typography variant="caption">able as before problem</Typography>
                </Grid>
                <PrettoSliderFunction
                    ValueLabelComponent={ValueLabelComponent}
                    valueLabelFormat={sliderValueLabelFormat}
                    getAriaValueText={sliderValueText}
                    aria-labelledby="self-rated-function-slider"
                    defaultValue={value}
                    onChange={(event, val) => setValue(Number(val))}
                    onChangeCommitted={(event, val) => setPendingValue(Number(val))}
                    value={value}
                    valueLabelDisplay="auto"
                    marks={sliderMarks}
                />
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center', marginTop: 30 }}>
                <Button
                    variant="contained"
                    disabled={pendingValue === null || pendingValue === initialValue || ((description || '').trim().length <= MIN_DESC || (description || '').trim().length > MAX_DESC)}
                    onClick={handleConfirm}
                    className={`${classes.confirmButton} ${pendingValue !== null ? classes.confirmPending : ''}`}
                >
                    {pendingValue === null ? 'Confirm' : `Confirm (${pendingValue})`}
                </Button>
            </Grid>
        </Grid>
    );
}

function HighlightedDescription({ description, placeholder, minLen, maxLen, onChange, classes }) {
    const [isEditing, setIsEditing] = useState(!description || description.trim().length === 0);

    useEffect(() => {
        if (!description || description.trim().length === 0) setIsEditing(true);
    }, [description]);

    return (
        <div style={{ width: '100%' }}>
            {isEditing ? (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <textarea
                        aria-label="activity-description"
                        placeholder={placeholder}
                        value={description || ''}
                        onChange={e => onChange(e.target.value.slice(0, maxLen))}
                        onBlur={() => {
                            if ((description || '').trim().length > minLen) setIsEditing(false);
                        }}
                        style={{
                            width: '100%',
                            minHeight: 80,
                            padding: 12,
                            fontSize: 18,
                            borderRadius: 8,
                            border: '2px solid #fb741a',
                            outline: 'none',
                            resize: 'vertical',
                            background: 'transparent',
                        }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                        <div style={{ color: (description || '').trim().length <= minLen ? '#b23a00' : '#486d86' }}>
                            {(description || '').trim().length <= minLen ? `Please describe the activity (more than ${minLen} chars)` : `${(description || '').trim().length}/${maxLen}`}
                        </div>
                    </div>
                </div>
            ) : (
                <Paper elevation={3} style={{ padding: 14, borderRadius: 10, background: 'linear-gradient(90deg,#fff8e6,#fefdfb)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1 }}>
                        <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#002D55', fontSize: 18 }}>{description || placeholder}</Typography>
                    </div>
                    <div style={{ marginLeft: 12 }}>
                        <IconButton onClick={() => setIsEditing(true)} aria-label="edit" size="small">
                            <EditIcon style={{ color: '#002D55' }} />
                        </IconButton>
                    </div>
                </Paper>
            )}
        </div>
    );
}

function SelfRatedNPSComp({ data, selectedChoiceCallback, styleComp }) {
    const classes = useStyles();
    const isMobile = useMediaQuery('(max-width:600px)');
    // NPS default range 0-10
    const [value, setValue] = useState(data && data.defaultValue !== undefined ? data.defaultValue : 5);
    const [pendingValue, setPendingValue] = useState(null);
    const [description, setDescription] = useState(data && data.description ? data.description : "");

    useEffect(() => {
        setValue(data && data.defaultValue !== undefined ? data.defaultValue : 5);
        setPendingValue(null);
        setDescription(data && data.description ? data.description : "");
    }, [data && data.id]);

    const handleConfirm = () => {
        if (pendingValue !== null) {
            // send object so backend add_answers_to_assessment will store numeric_value and text_value
            const payload = { value: pendingValue, description: (description || "").trim(), text: (description || "").trim() };
            selectedChoiceCallback(payload);
            setPendingValue(null);
        }
    };

    const marks = Array.from({ length: 11 }).map((_, i) => ({ value: i, label: String(i) }));

    return (
        <Grid container direction="column" style={{ padding: 10 }}>
            <Typography
                variant={isMobile ? 'subtitle1' : 'h6'}
                style={{
                    color: '#002D55',
                    maxWidth: isMobile ? '100%' : 900,
                    whiteSpace: 'break-spaces',
                    fontSize: isMobile ? '1rem' : undefined,
                    lineHeight: isMobile ? 1.2 : undefined,
                }}
            >
                <TypingText text={data && data.title ? data.title : 'On a scale from 0 to 10, how satisfied are you so far?'} speed={0} />
            </Typography>

            <Grid container direction="column" style={{ padding: 8, marginTop: 8, maxWidth: 900 }}>
                <TextField
                    value={description}
                    type="text"
                    placeholder={data && data.descriptionPlaceholder ? data.descriptionPlaceholder : "Anything we do really good or that we can improve on?"}
                    onChange={(event) => setDescription(event.target.value)}
                    variant="outlined"
                    fullWidth
                    style={{ marginBottom: 12 }}
                />

                <PrettoSliderFunction
                    ValueLabelComponent={ValueLabelComponent}
                    valueLabelFormat={sliderValueLabelFormat}
                    getAriaValueText={sliderValueText}
                    aria-labelledby="self-rated-nps-slider"
                    defaultValue={value}
                    onChange={(event, val) => setValue(val)}
                    onChangeCommitted={(event, val) => setPendingValue(val)}
                    value={value}
                    valueLabelDisplay="on"
                    marks={marks}
                    step={1}
                    min={0}
                    max={10}
                />
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center', marginTop: 12 }}>
                <Button
                    variant="contained"
                    disabled={pendingValue === null}
                    onClick={handleConfirm}
                    className={`${classes.confirmButton} ${pendingValue !== null ? classes.confirmPending : ''}`}
                >
                    {pendingValue === null ? 'Confirm' : `Confirm (${pendingValue})`}
                </Button>
            </Grid>
        </Grid>
    );
}

function SelfRatedPainComp({ data, selectedChoiceCallback, styleComp }) {
    const classes = useStyles();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [value, setValue] = useState(data && data.defaultValue ? data.defaultValue : 0);
    const [pendingValue, setPendingValue] = useState(null);

    useEffect(() => {
        setValue(data && data.defaultValue ? data.defaultValue : 0);
        setPendingValue(null);
    }, [data && data.id]);

    const handleConfirm = () => {
        if (pendingValue !== null) {
            selectedChoiceCallback(String(pendingValue));
            setPendingValue(null);
        }
    };

    return (
        <Grid container direction="column" style={{ padding: 10 }}>
            <Typography
                variant={isMobile ? 'subtitle1' : 'h6'}
                className={data.questionClassName || ""}
                style={{
                    color: '#002D55',
                    maxWidth: isMobile ? '100%' : 900,
                    whiteSpace: 'break-spaces',
                    marginBottom: isMobile ? 14 : 25,
                }}
            >
                <TypingText text={data && data.title ? data.title : 'From 0-100, rate your pain level'} speed={0} />
            </Typography>
            <Grid container direction="column">
                <Grid container justify="space-between" style={{ marginTop: 6, paddingLeft: 4, paddingRight: 2 }}>
                    <Typography variant="caption">no pain</Typography>
                    <Typography variant="caption">mild</Typography>
                    <Typography variant="caption">moderate</Typography>
                    <Typography variant="caption">high</Typography>
                    <Typography variant="caption">worst pain imaginable</Typography>
                </Grid>
                <PrettoSliderPain
                    ValueLabelComponent={ValueLabelComponent}
                    valueLabelFormat={sliderValueLabelFormat}
                    getAriaValueText={sliderValueText}
                    aria-labelledby="self-rated-pain-slider"
                    defaultValue={value}
                    onChange={(event, val) => setValue(val)}
                    onChangeCommitted={(event, val) => setPendingValue(val)}
                    value={value}
                    valueLabelDisplay="auto"
                    marks={sliderMarks}
                />
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center', marginTop: isMobile ? 14 : 25 }}>
                <Button
                    variant="contained"
                    disabled={pendingValue === null}
                    onClick={handleConfirm}
                    className={`${classes.confirmButton} ${pendingValue !== null ? classes.confirmPending : ''}`}
                >
                    {pendingValue === null ? 'Confirm' : `Confirm`}
                </Button>
            </Grid>
        </Grid>
    );
}



const FreeTextInputComp = (data, selectedChoiceCallback, styleComp, answer, setAnswer, error, setError) => {
    const selectedChoiceCallbackWrapper = () => {
        const emailValidator = email => {
            return new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(email)
            
        }
        const numericValidator = (numericValue, low, high) => {
            const numericParsedValue = parseInt(numericValue)
            
            if (isNaN(numericParsedValue)) {
                return null
            } else {
                console.log(low)
                console.log(high)
                if (low <= numericValue && high >= numericValue) {
                    return numericValue
                } else {
                    return null
                }
            }
        }
        
        switch(data.tag) {
            case "normal":
                setError(null)
                selectedChoiceCallback(answer)
                break;
            case "email":
                if (emailValidator(answer)) {
                    setError(null)
                    selectedChoiceCallback(answer)
                } else {
                    // Show error to user

                }
                break
            case "numeric" + data.tag.substring(data.tag.indexOf(":"), data.tag.length):
                const low = data.tag.substring(data.tag.indexOf(":")+1, data.tag.indexOf("-"))
                const high = data.tag.substring(data.tag.indexOf("-")+1, data.tag.length) 

                if (numericValidator(answer, parseInt(low), parseInt(high))){
                    setError(null)
                    selectedChoiceCallback(answer)
                } else {
                    setError("Please type in a number between 0-100")
                }
                break
            
            default:
                setError(null)
                selectedChoiceCallback(answer)
        }
    }

    const keyPressHandler = event => {
        if (event.key === 'Enter') {
            selectedChoiceCallbackWrapper()
          }
    }

    return <Grid container direction="column" >
        <InputLabel >
            <Typography
                variant="h5"
                className={data.questionClassName || ""}
                style={{color: "#002D55", maxWidth: 800, margin: 12}}
            >
                <TypingText text={data.title} speed={0} />
            </Typography>
        </InputLabel>
    {error != null ? <InputLabel style={{marginLeft: 12, marginBottom: 5}}>{error}</InputLabel> : null}
        <TextField
            value={answer}
            type="text"
            label={data.sub_title ? data.sub_title : " "}
            onChange={event => setAnswer(event.target.value)}
            onKeyDown={keyPressHandler}
            style={{padding: 0, minWidth: 400, marginLeft: 12, marginRight: 12, color: "#002D55"}}
            variant="outlined"
            classes={{ root: styleComp.orangeFocused }}
        />
        <Grid container direction="row" style={{justifyContent: "center"}}>
            <Button 
            style={{ 
            display: "flex", 
            justifyContent: "center", marginTop: 20, width: 50, fontSize: 18, marginBottom: -15, 
            color: "#888" }} 
            onClick={selectedChoiceCallbackWrapper}
            >
            Next
            </Button>
        </Grid>
    </Grid>
}


//ligenu vises billedvalg på 1 lang kolonne og vil gerne have det til at vise som en mozaik eller firkant altså 3x3 rækker for eksempelt
const PictureChoiceComp = (data, selectedChoiceCallback, styleComp) => {
    return (
        <React.Fragment>
            <Container style={{ marginBottom: 10, maxWidth: 900, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <GridList style={{ width: '100%', margin: 0, display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }} cols={5}>
                    <GridListTile key="Title" cols={5} style={{ height: "auto", width: '100%' }}>
                        <Typography
                            variant="h5"
                            className={data.questionClassName || ""}
                            style={{ color: "#002D55", textAlign: 'center', width: '100%' }}
                        >
                            <TypingText text={data.title} speed={0} />
                        </Typography>
                    </GridListTile>
                    {data.answers.map((item) => (
                        <GridListTile
                            key={item.answerId}
                            className="assessment-picture-tile"
                            style={{ minHeight: 220, minWidth: 180, width: '18%', margin: '0%' }}
                        >
                            <img
                                src={item.imgUrl}
                                className="assessment-picture-img"
                                style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: 8 }}
                                onClick={() => selectedChoiceCallback(item.answerId)}
                            />
                            <div onClick={() => selectedChoiceCallback(item.answerId)}>
                                <GridListTileBar
                                    title={`${item.answerId}) ${item.answerTitle}`}
                                    subtitle={item.answerText}
                                />
                            </div>
                        </GridListTile>
                    ))}
                </GridList>
            </Container>
        </React.Fragment>
    );
}

function Question(props) {
    const classes = useStyles();
    const [questionId, setQuestionId] = useState(null)
    const [selectedAnswerIfNessesery, setSelectedAnswerIfNessesery] = useState("");
    const [error, setError] = useState(null);


    
    console.log(props.questionData)
    useEffect(() => {
        if (props.questionData) {
            setQuestionId(props.questionData.id)
        }

    }, [props.questionData]);


    useEffect(() => {
        setSelectedAnswerIfNessesery("")
    }, [props.questionData])

    if(props.questionData && props.questionData.adderionTitleValue) {
        props.questionData.title = props.questionData.title.replace("__VAL__", props.questionData.adderionTitleValue)
    }


    if (props.questionData) {
        var Question = null;
        const questionClassName = props.questionClassName || "";
        switch (props.questionData?.questionType || props.questionData?.type) {
            case "multipleChoice":
            case "diagnoseQuestion":
                // Hybrid CV enhancement: if this question has a cvTestConfig, show
                // the camera test option above the normal answer cards
                const _isDualRight = /neckRotationRangeOfMovementRight$/i.test(props.questionData?.identifier || '');
                if (props.questionData?.cvTestConfig || _isDualRight) {
                    Question = (
                      <HybridCvMultipleChoice
                        data={{...props.questionData, questionClassName}}
                        selectedChoiceCallback={props.nextQuestionHandler}
                        styleComp={classes.multipleChoice}
                      />
                    );
                } else {
                    Question = (
                      <MultipleChoiceComp
                        data={{...props.questionData, questionClassName}}
                        selectedChoiceCallback={props.nextQuestionHandler}
                        styleComp={classes.multipleChoice}
                      />
                    );
                }
                break;
            case "dropDown":
                Question = DropDownComp({...props.questionData, questionClassName}, props.nextQuestionHandler, classes.dropdown)
                break;
            case "pictureChoice":
                if (props.questionData?.cvTestConfig) {
                    Question = (
                      <HybridCvMultipleChoice
                        data={{...props.questionData, questionClassName}}
                        selectedChoiceCallback={props.nextQuestionHandler}
                        styleComp={classes.multipleChoice}
                      />
                    );
                } else {
                    Question = PictureChoiceComp({...props.questionData, questionClassName}, props.nextQuestionHandler, classes.pictureChoice)
                }
                break;
            case "inputText":
                Question = FreeTextInputComp({...props.questionData, questionClassName}, props.nextQuestionHandler, classes, selectedAnswerIfNessesery, setSelectedAnswerIfNessesery, error, setError)
                break;
            case "selfRatedFunction":
                Question = (
                    <SelfRatedFunctionComp
                        data={{...props.questionData, questionClassName}}
                        selectedChoiceCallback={props.nextQuestionHandler}
                        styleComp={{}}
                    />
                );
                break;
            case "selfRated_NPS":
                Question = (
                    <SelfRatedNPSComp
                        data={{...props.questionData, questionClassName}}
                        selectedChoiceCallback={props.nextQuestionHandler}
                        styleComp={{}}
                    />
                );
                break;
            case "selfRatedPain": {
                // robust identifier detection: try several fields and a title heuristic
                const qIdentifier = props.questionData?.identifier || props.questionData?.question?.identifier || props.questionData?.id || props.questionData?.questionId || "";
                const titleText = (props.questionData?.title || props.questionData?.question || "").toString();
                const lowerTitle = titleText.toLowerCase();

                // debug: show what we detect
                console.log('[Question] selfRatedPain branch — qIdentifier:', qIdentifier, 'title:', titleText, 'questionType:', props.questionData?.questionType);

                // If this wrapper is actually the NPS question (old DB rows may be mapped to pain),
                // render the NPS component instead of the pain UI. We accept either an explicit
                // identifier or a title heuristic because some DB rows omit `identifier`.
                const looksLikeNPS = (qIdentifier || '').toString().trim().toLowerCase() === 'selfrated_nps'
                    || /how satisfied|satisfied are you|satisfaction|how satisfied are you/i.test(lowerTitle);

                if (looksLikeNPS) {
                    Question = (
                        <SelfRatedNPSComp
                            data={{...props.questionData, questionClassName}}
                            selectedChoiceCallback={props.nextQuestionHandler}
                            styleComp={{}}
                        />
                    );
                    break;
                }

                const isFrequency = qIdentifier === "frequency_of_symptoms_2"
                    || qIdentifier === "frequency_of_symptoms"
                    || /days a week|how many days|frequency of symptoms/i.test(titleText);

                if (isFrequency) {
                    Question = (
                        <FrequencySliderComp
                            data={{...props.questionData, questionClassName}}
                            selectedChoiceCallback={props.nextQuestionHandler}
                            styleComp={{}}
                        />
                    );
                } else {
                    Question = (
                        <SelfRatedPainComp
                            data={{...props.questionData, questionClassName}}
                            selectedChoiceCallback={props.nextQuestionHandler}
                            styleComp={{}}
                        />
                    );
                }
                break;

            }
            case "symptomFrequency":
                Question = (
                    <FrequencySliderComp
                        data={{...props.questionData, questionClassName}}
                        selectedChoiceCallback={props.nextQuestionHandler}
                        styleComp={{}}
                    />
                );
                break;
            case "computerVisionTest":
                Question = (
                    <ComputerVisionTest
                        data={{...props.questionData, questionClassName}}
                        selectedChoiceCallback={props.nextQuestionHandler}
                    />
                );
                break;
        }
    }


    return props.questionData ? (
        <>
            <style>{`
                /* Responsive sizing for answer cards */
                @media (max-width: 600px) {
                    .assessment-card-responsive {
                        min-width: 120px !important;
                        max-width: 98vw !important;
                        width: 80vw !important;
                        min-height: 30px !important;
                        max-height: 70px !important;
                    }
                }
                @media (min-width: 600px) and (max-width: 960px) {
                    .assessment-card-responsive {
                        min-width: 180px !important;
                        max-width: 720px !important;
                        width: 80vw !important;
                        min-height: 30px !important;
                        max-height: 70px !important;
                    }
                }
                @media (min-width: 960px) and (max-width: 1280px) {
                    .assessment-card-responsive {
                        min-width: 220px !important;
                        max-width: 720px !important;
                        width: 80vw !important;
                        min-height: 30px !important;
                        max-height: 56px !important;
                    }
                }
                @media (min-width: 1280px) and (max-width: 1920px) {
                    .assessment-card-responsive {
                        min-width: 260px !important;
                        max-width: 800px !important;
                        width: 80vw !important;
                        min-height: 30px !important;
                        max-height: 56px !important;
                    }
                }
                @media (min-width: 1920px) {
                    .assessment-card-responsive {
                        min-width: 320px !important;
                        max-width: 900px !important;
                        width: 80vw !important;
                        min-height: 30px !important;
                        max-height: 48px !important;
                    }
                }

                /* Hover effect: orange background and white text */
                .assessment-card-responsive:hover {
                    background-color: #fb741a !important;
                    color: #fff !important;
                    border-color: #fb741a !important;
                }

                /* Ensure inner text also becomes white on hover */
                .assessment-card-responsive:hover .MuiTypography-root {
                    color: #fff !important;
                }

                /* Picture tile image hover: orange border and slight scale */
                    .assessment-picture-tile img,
                    .assessment-picture-img {
                        border: 2.5px solid transparent;
                        border-radius: 8px;
                        transition: border-color 180ms ease;
                        display: block;
                        cursor: pointer;
                    }

                    /* Hover: orange border (no transform) */
                    .assessment-picture-tile:hover img,
                    .assessment-picture-img:hover {
                        border-color: #fb741a !important;
                    }

                    /* Click/active or keyboard focus: green border */
                    .assessment-picture-tile:active img,
                    .assessment-picture-img:active,
                    .assessment-picture-img:focus,
                    .assessment-picture-tile:focus img {
                        border-color: #002D55 !important;
                    }
                `}</style>
            <div>{Question}</div>
        </>
    ) : <div>Loading...</div>
}

export default Question;

